import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

import { List } from "react-bootstrap-icons";
import "./sub-header.scss";
const SubHeader = ({ toggleSidebar, breadcrums }) => {
  return (
    <div className="sub-header-container">
      <List
        className="sub-header-container__icon"
        onClick={() => toggleSidebar()}
      />
      <Breadcrumb className="sub-header-container__breadcrum">
        {
          breadcrums.map((element) => {
            return (
              <BreadcrumbItem>
                <Link to={element.link}>{element.title}</Link>
              </BreadcrumbItem>
            );
          })
        }
      </Breadcrumb>
    </div>
  );
};
export default SubHeader;
